import carouselInit from "../js/src/carousel";
import {landingWithMenu} from "@/js/src/landingWithMenu";
import {blazyEventEmit, initMainHeader} from "@/js/src/header-init";
import '../scss/pages/ai-servers.scss';



initMainHeader({ blazy: {
    success: (e) => blazyEventEmit(e)
}});

carouselInit(8000);

landingWithMenu({
    menu: document.querySelector('nav.sub-nav'),
    sectionList: document.querySelectorAll('.ai-section')
});

/**
 *
 * @type {Element}
 */
const parent = document.querySelector('main.content');

parent.addEventListener('mouseover', (event) => {
    const link = event.target;

    if (link.classList.contains('file-link1')) {
        const parent = link.closest('.col, .col-4, .container');
        const img = parent ? parent.querySelector('img') : null;

        if (img) {
            img.src = link.getAttribute('data-src');
            img.style.opacity = '0.3';
            img.onload = () => img.style.opacity = '1';
        }
    }
});
